import { useId } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { SubmissionMessageComposer } from "@/components/bond-submission/SubmissionMessageComposer";

// BRK-S425 — the header's Message Underwriter dialog on a v2 order: the
// Messages tab's own composer (topic chips and message), posting to the
// order's thread. It closes only after the 2xx, and the host then re-reads the
// thread; a refusal keeps it open with the error and the text.

export function SubmissionMessageDialog({
  open,
  submissionId,
  number,
  onClose,
  onSent,
}: {
  open: boolean;
  submissionId: string;
  /** The SB number, for the subtitle. */
  number: string;
  onClose: () => void;
  /** After the 2xx; the host closes the dialog and re-reads the thread. */
  onSent: () => void;
}) {
  const titleId = useId();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby={titleId}
    >
      <DialogTitle id={titleId}>Message Signal</DialogTitle>
      <DialogContent>
        <div className="flex min-w-0 flex-col gap-4">
          <div className="flex flex-col gap-0.5 text-sm">
            <p className="tabular-nums text-brk-dim">{number}</p>
            <p className="text-brk-text">
              <span className="text-brk-dim">To </span>
              Signal surety
            </p>
          </div>
          <SubmissionMessageComposer
            submissionId={submissionId}
            label="Message"
            note="Saved to this submission’s history. Replies come to your email."
            onSent={onSent}
            onCancel={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
